import React, { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { GoogleLogin } from '@react-oauth/google';
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

const UserSignIn = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const [eyePassword, setEyePassword] = useState(false)
  const [showEyePassword, setShowEyePassword] = useState(false)

  const handleGoogleLoginSuccess = (credentialResponse) => {
    debugger
    const token = credentialResponse.credential;
    const decoded = jwtDecode(token);


    const userData = {
      name: decoded.name,
      email: decoded.email,
      picture: decoded.picture,
    };

    axios
      .post("https://api.bakpoket.com/api/Auth/google-login", {
        name: userData.name,
        Username: userData.name,
        email: userData.email,
      })
      .then((res) => {
        // alert("Google Login Success" )
      })
      .catch((err) => {
        console.error("Login Failed:", err);
        alert("Login Failed");
      });
    localStorage.setItem('userLogin', JSON.stringify(userData));
    localStorage.setItem('googleLogin', true);
    setUsername(decoded.name || '');
    setEmail(decoded.email || '');
    navigate("/");
  };


  const userhandleLogin = async (e) => {
    e.preventDefault();

    if (password.length < 8) {
      setError("Password must be at least 8 characters long");
      return;
    }

    try {
      const response = await axios.post('https://api.bakpoket.com/api/UserDetail1/Login', {
        username,
        // email,
        password,
      });
      localStorage.setItem('userLogin', JSON.stringify(response.data));
      localStorage.setItem('googleLogin', false);
      localStorage.setItem('LoginTimestamp', Date.now());
      alert('Login successful!');
      navigate('/');
      window.location.reload();
    } catch (error) {
      console.error('Login failed:', error);
      alert('Login failed. Please try again.');
    }
  };


  return (
    <div>
      <Wrapper className='my-3'>
        <div className="login-main-card">
          <p className="top-text">EARN CASHBACK EVERY TIME YOU SHOP</p>
          <h5>Sign In with BakPoket</h5>

          <div className="login-options">
            <div className="login-type">
              <GoogleLogin
                onSuccess={(response) => handleGoogleLoginSuccess(response, true)}
                onError={() => console.log('Google Login Failed')}
              />
            </div>
          </div>

          <div className="or-divider"><span>OR</span></div>

          <form className="auth-form" onSubmit={userhandleLogin}>
            <input
              type="text"
              placeholder="User Name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
            {/* <input
              type="text"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            /> */}
            <div style={{ position: 'relative' }}>
              <input
                type={showEyePassword ? 'text' : 'password'}
                placeholder="Password must contain 8 characters"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (e.target.value.length >= 8) setError('');
                }}
                required style={{ width: '100%' }}
              />
              {password.length > 0 ? (
                eyePassword ? (<FaEyeSlash style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setEyePassword(false); setShowEyePassword(false) }} />)
                  : (<FaEye style={{ position: 'absolute', right: '10', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer' }} onClick={() => { setEyePassword(true); setShowEyePassword(true) }} />)) : (null)
              }
            </div>
            
            {error && <p className='mb-0' style={{ color: "red", fontSize: "12px" }}>{error}</p>}
            <button type="submit" className="auth-btn">Sign In</button>
          </form>
              <SwitchText>
              <span><NavLink to='/userForgotPassword' style={{ textDecoration: 'none', color: '#ef4766' }}>Forgot Password</NavLink></span>
            </SwitchText>
          <SwitchText>
            Don’t have an account?  <NavLink to='/userSignup' style={{ textDecoration: 'none' }}><span>Sign Up</span></NavLink>
          </SwitchText>
        </div>
      </Wrapper>
    </div>
  )
}

export default UserSignIn;


const Wrapper = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;

  .login-main-card {
    background-color: rgb(233, 231, 231);
    width: 100%;
    max-width: 420px;;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .top-text {
    font-weight: bold;
    color: #444;
    margin-bottom: 10px;
  }

  h2 {
    margin-bottom: 25px;
    color: #222;
  }

  .login-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 0px;
  }

  .login-type {
    display: flex;
    justify-content: center;
  }

  .or-divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 10px 0;

    span {
      background-color: rgba(71, 70, 70, 0.1);
      padding: 3px;
      color: #666;
      font-weight: 600;
      border-radius: 50%;
    }

    &::before,
    &::after {
      content: '';
      flex: 1;
      height: 1px;
      background: #999;
    }
  }

  .auth-form {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input {
      padding: 7px;
      border-radius: 6px;
      border: 1px solid #ccc;
      font-size: 13px;
    }
  }

  .auth-btn {
    background-color: #ef4766;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 6px;
    font-weight: bold;
    width: 100%;
    font-size: 16px;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
      background-color: #d91212;
    }
  }
`;

const SwitchText = styled.p`
  font-size: 13px;
  margin-top: 10px;
  margin-bottom: 0px;

  span {
    color: #ef4766;
    cursor: pointer;
    font-weight: bold;
  }

  @media (max-width: 600px) {
    font-size: 9px;
    margin-top: 2px;
    margin-bottom: 2px;
  }
`;

